export const CHANGE_VALUE_HANDLER = 'CHANGE_VALUE_HANDLER';
export const CHANGE_NO_DECORATION_HANDLER = 'CHANGE_NO_DECORATION_HANDLER';

//auth
export const AUTH = 'AUTH';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
